export const NYCLat=40.7128;export const NYCLng=-74.006;export const NYC={lat:NYCLat,lng:NYCLng};export const MID_USA={lat:39.8283,lng:-98.5795};